export const showCover = function () {
  // @ts-expect-error
  const board = this.model.getBoard();
  return (
    // Assume board is nullable since it can't be retrieved sometimes
    // @ts-expect-error
    board?.getPref('cardCovers') && this.model.hasCover() && !this.onCalendar
  );
};
